/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FavoriteItem = {
    properties: {
        id: {
    type: 'number',
},
        category: {
    type: 'IdName',
    isRequired: true,
},
        employee: {
    type: 'IdName',
    isRequired: true,
},
        item: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
},
    },
};